'use client'

import { useCommunityThreads } from '@/hooks/react-query/community-v2/use-community-threads'
import { ThreadSection } from '@/types/community-threads'
import { useRef, useState } from 'react'
import { AMBASSADORS_DATA } from '../data'
import { AmbassadorBottom } from './ambassador-bottom'
import { AmbassadorHero } from './ambassador-hero'
import { AmbassadorMiddle } from './ambassador-middle'
import { AmbassadorTabs } from './ambassador-tabs'
import { CampaignListSection } from './campaign/campaign-list-section'

export const CommunityAmbassador = () => {
  const { data: config, isLoading } = useCommunityThreads()
  const [activeTab, setActiveTab] = useState<string>('ca-nhan')
  const sectionRef = useRef<HTMLElement>(null)

  if (isLoading) return null

  const tabs = [
    { id: 'ca-nhan', tabName: config?.personal?.title || 'CÁ NHÂN ĐỒNG HÀNH' },
    {
      id: 'cau-lac-bo',
      tabName: config?.club?.title || 'CÂU LẠC BỘ ĐỒNG HÀNH',
    },
    {
      id: 'don-vi',
      tabName: config?.unit?.title || 'ĐƠN VỊ / TỔ CHỨC ĐỒNG HÀNH',
    },
  ]

  const getSectionData = (id: string): ThreadSection | undefined => {
    switch (id) {
      case 'ca-nhan':
        return config?.personal
      case 'cau-lac-bo':
        return config?.club
      case 'don-vi':
        return config?.unit
      default:
        return config?.personal
    }
  }

  const currentSection = getSectionData(activeTab)
  const fallbackData =
    AMBASSADORS_DATA.find((t) => t.id === activeTab) || AMBASSADORS_DATA[0]

  const handleTabChange = (id: string) => {
    setActiveTab(id)
    const header = document.querySelector('header[aria-label="Site header"]')
    const headerHeight = header ? header.getBoundingClientRect().height : 0
    
    if (sectionRef.current) {
      const topPosition = sectionRef.current.getBoundingClientRect().top + window.scrollY - headerHeight
      window.scrollTo({ top: topPosition, behavior: 'smooth' })
    }
  }

  return (
    <section ref={sectionRef} className='w-full bg-[#f8f8f8]'>
      <AmbassadorTabs
        tabs={tabs}
        activeTab={activeTab}
        onChange={handleTabChange}
      />
      <div className='w-full px-6 py-10 md:px-15 md:py-20'>
        <AmbassadorHero data={fallbackData.hero} />
        <AmbassadorMiddle data={fallbackData.middleSection} />
        {currentSection && <AmbassadorBottom data={currentSection} />}
        <CampaignListSection />
      </div>
    </section>
  )
}
